import { FC, useEffect, useState } from 'react';

import { Box, BoxProps, Flex, Img } from '@chakra-ui/react';
import { Booster, Card, Contest } from 'models';

import { LeagueStatItem, mapLeagueStats } from './utils/leagueStatsMapper';

const DetailedCard: FC<{ card: Card; booster?: Booster | null; contest?: Contest | null }> = ({
  card,
  booster,
  contest,
}) => {
  const headshot =
    card?.headshotThumbnails?.small ?? card?.headshotThumbnails?.medium ?? card?.headshotThumbnails?.original ?? '';
  const [hasModifier, setHasModifier] = useState(false);
  const [leagueStats, setLeagueStats] = useState<LeagueStatItem[]>([]);

  useEffect(() => {
    setHasModifier(!!card?.modifier);
  }, [card]);

  useEffect(() => {
    const stats = mapLeagueStats(card, contest, booster);
    setLeagueStats(stats);
  }, [card, contest, booster]);

  return (
    <Box px="12px" pt="12px" pb="24px">
      <Flex gap="8px" alignItems="center">
        <Box
          w="44px"
          h="44px"
          mx="auto"
          backgroundSize="cover"
          position="relative"
          borderRadius="16px"
          flexShrink="0"
          flexGrow="0"
          bgColor={card.status === 'bench' ? '#343434' : card.status === 'cut' ? '#B83B3B' : 'white'}
          _before={{
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '16px',
            backgroundImage: `url(${headshot})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            filter: card.status === 'cut' ? 'grayscale(100%)' : '',
          }}
        />
        <Box color="white" flexBasis="100%">
          <Box
            textTransform="uppercase"
            letterSpacing="4%"
            fontFamily="JetBrains Mono"
            fontSize="12px"
            fontWeight="500"
            lineHeight="14.4px"
          >
            {card?.playerFirstName}
          </Box>
          <Box
            textTransform="uppercase"
            fontFamily="JetBrains Mono"
            fontSize="18px"
            fontWeight="500"
            lineHeight="18px"
            mt="2px"
          >
            {card?.playerLastName}
          </Box>
        </Box>
        <Flex flexShrink="0" alignItems="center" justifyContent="center" height="100%" gap="2px">
          {/* <Img w="16px" src="/coin.png" /> */}
          <Box fontSize="18px" fontWeight="700">
            {card.totalPoints}
          </Box>
        </Flex>
      </Flex>
      {leagueStats.length > 0 && (
        <Box pl="52px" fontSize="13px" pt="4px" fontWeight="500" color="#FFFFFFCC" lineHeight="15.6px">
          {leagueStats.map((stat, index) => (
            <Flex key={index} align="center" justify="space-between" mt={index > 0 ? '8px' : '0'}>
              <Box>{stat.label}</Box>
              <Box
                fontSize="13px"
                fontWeight="600"
                color="white"
                flexBasis="100px"
                flexShrink="0"
                flexGrow="0"
                textAlign="right"
                lineHeight="15.6px"
              >
                {stat.value}
              </Box>
            </Flex>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default DetailedCard;
